// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"289":"7e46586b","787":"0bc2e05e"}[chunkId] + ".chunk.js";
};